
export { default as CreateExitMobileIcon } from "./create_exit_mobile_icon.svg"
export { default as CreateRulesIcon } from "./create_icon_rules.svg"
export { default as CreateSelectedIcon } from "./create_icon_seleted.svg"
export { default as CreateSelectedMobileIcon } from "./create_icon_seleted_mobile.svg"
export { default as NavBackOutlinedMobileIcon } from "./nav_icon_back_outlined_mobile.svg"
export { default as TagEventIcon } from "./tags/tag_event.svg"
export { default as TagNewIcon } from "./tags/tag_new.svg"